/** How a signed-in person is named and labelled in the account menu and on their profile. */

const ROLE_NAMES: Record<string, string> = {
  admin: "Administrator",
  cfo: "Chief finance officer",
  bursar: "Bursar",
  head_teacher: "Head teacher",
  director_of_studies: "Director of studies",
  head_of_department: "Head of department",
  school_doctor: "School nurse / doctor",
  board_viewer: "Board member",
  donor_viewer: "Donor",
};

/** "director_of_studies" → "Director of studies"; a few read better spelt out. */
export function roleName(userType: string | null | undefined) {
  if (!userType) return "";
  if (ROLE_NAMES[userType]) return ROLE_NAMES[userType];
  const words = userType.replace(/_/g, " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function displayName(user: { full_name?: string; first_name?: string; last_name?: string; username?: string } | null | undefined) {
  if (!user) return "";
  return user.full_name?.trim() || `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() || user.username || "";
}

/** Up to two initials from the name, or "?" when there is none. */
export function initialsOf(name: string) {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("") || "?"
  );
}
